import { Note } from 'one-card-notes-history';
import { format } from 'one-util-date';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Pending Referal component
 * @param response is the raw json data returned from API.
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let notes: Note[] = [];
    let result: any = {
        notes: undefined,
        error: undefined
    }
    if (response && (response.status >= 400 || response.type == "error" )) {
        result.error = response;
    }
    else if(response.http_code>=400){
        console.log(response,"response")
        result.error = response;
    }
    else if (response && response.length > 0) {
        response.forEach((ele: any) => {
            let info: Note = {
                note: ele.notes ?? '',
                agentId: ele.agent_id ?? '',
                date: format(ele.datetime, 'MM-DD-YYYY'),
                time: format(new Date(ele.datetime), 'hh:mm:ss A'),
                isEpic: ele.is_epic === 't' ? true : false
            };
            notes.push(info);
        });
        result.notes = notes;
    }

    return result;
}
